import React from "react";
import PropTypes from "prop-types";
import styles from "./styles.css";
import { Badge } from "@cars24/turbo-web/lib/badge";
import {Text} from "@cars24/turbo-web/lib/text";
import { useTokens } from "@cars24/turbo-web/lib/theme-provider";

const PostInspectionMarketplaceListingStatus = ({
    title,
    description,
    badge
}) => {
    const {tokens} = useTokens();
    return (
        <div styleName="styles.statusWrapper">
            <div styleName="styles.header">
                <Text size="450" fontWeight="semibold">
                    {title}
                </Text>
                <Badge
                    type={badge.type || "dark"}
                    label={badge.label}
                    variant={badge.variant || "success"}
                    icon={badge.icon && <img src={badge.icon} alt={badge.label} style={{height: 12, width: 12}}/>}
                />
            </div>
            <Text size="200" color={tokens.text_default_text_secondary}>{description}</Text>
        </div>
    );
};

PostInspectionMarketplaceListingStatus.propTypes = {
    title: PropTypes.string,
    description: PropTypes.string,
    ctaText: PropTypes.string,
    badge: PropTypes.object,
    onClick: PropTypes.func
};

export default PostInspectionMarketplaceListingStatus;
